import { SurveyPoint } from '@core/interfaces/survey-point';
import { SurveyPointLocation } from '@core/interfaces/survey-point-location';

export class SurveyFileHelper {
  public static getIdTypeName(code: string, idTypes: Array<{ name: string; code: string }>): string {
    return idTypes.find(idType => idType.code === code)?.name ?? '';
  }

  public static setMeasurementToZeroForNullValue(cml: SurveyPoint): SurveyPoint {
    const surveyMeasurementData = cml.ids.map(res => ({
      ...res,
      measurement: SurveyFileHelper.#toFiniteNumber(res.measurement),
      previousMeasurement: SurveyFileHelper.#toFiniteNumber(res.previousMeasurement),
    }));

    const cmlLocation: SurveyPointLocation = {
      left: Math.round(cml.location.left ?? 0),
      top: Math.round(cml.location.top ?? 0),
      height: Math.round(cml.location.height ?? 48),
      width: Math.round(cml.location.width ?? 48),
    };

    const surveyPointData: SurveyPoint = {
      id: cml.id,
      label: cml.label,
      measurementStatus: cml.measurementStatus,
      location: cmlLocation,
      ids: surveyMeasurementData,
      isCustom: cml?.isCustom,
    };
    return surveyPointData;
  }

  // Measurements reach this helper from nullable SQLite varchar columns and from the edit table inputs, so
  // anything that is not a finite number (null, undefined, '', '.') has to collapse to 0 before being
  // persisted or synced — the backend deserializes these into a non-nullable double.
  static #toFiniteNumber(value: number): number {
    const numericValue = Number(value);
    return Number.isFinite(numericValue) ? numericValue : 0;
  }
}
